import { VideoImageText } from "hec/components/video-image-text";

import type { RegisteredComponent } from "@builder.io/sdk-react";

export const VideoImageTextDefinition: RegisteredComponent = {
  component: VideoImageText,
  name: "VideoImageText",
  noWrap: true,
  inputs: [
    {
      name: "sectionTitle",
      type: "string",
      required: false,
      defaultValue: "See the Product in Action",
    },
    {
      name: "videoUrl",
      type: "string",
      required: true,
      helperText: "YouTube watch or share URL",
      defaultValue: "",
    },
    {
      name: "blocks",
      type: "list",
      required: false,
      defaultValue: [],
      subFields: [
        {
          name: "imageUrl",
          type: "file",
          allowedFileTypes: ["jpeg", "jpg", "png", "webp", "svg", "gif"],
          required: true,
        },
        {
          name: "title",
          type: "string",
          required: false,
          defaultValue: "Block title",
        },
        {
          name: "description",
          type: "richText",
          required: false,
          defaultValue: "<p>Block description</p>",
        },
        {
          name: "imagePosition",
          type: "string",
          enum: ["left", "right"],
          defaultValue: "left",
          required: false,
        },
      ],
    },
  ],
};
